export default "__VITE_ASSET__15d4b742__"